/** Descrição curta de uma sigla de imposto/tributo — usada em tooltip de entendimento. */
export function impostoDesc(sigla: string): string {
  const s = (sigla || '').toUpperCase().trim();

  // ICMS e variantes
  if (s === 'ICMSA' || s.startsWith('ICMS A')) {
    return 'ICMS Antecipado — ICMS recolhido na ENTRADA (compra, em geral interestadual), antes da venda. Comum no Simples Nacional (antecipação tributária).';
  }
  if (
    s === 'SUBTRI' ||
    s === 'ST' ||
    s.startsWith('ICMS-ST') ||
    s.startsWith('ICMS ST') ||
    s.endsWith('-ST')
  ) {
    return 'ICMS-ST (Substituição Tributária) — o ICMS de toda a cadeia é recolhido antecipadamente por um único contribuinte (o substituto).';
  }
  if (s.startsWith('DIFAL')) {
    return 'DIFAL — Diferencial de Alíquota do ICMS em operações interestaduais destinadas a consumidor final.';
  }
  if (s === 'FCP') return 'FCP — Fundo de Combate à Pobreza, um adicional do ICMS.';
  if (s.startsWith('ICMS'))
    return 'ICMS — Imposto sobre Circulação de Mercadorias e Serviços (estadual).';

  // Federais
  if (s.startsWith('COFI'))
    return 'COFINS — Contribuição para o Financiamento da Seguridade Social (federal).';
  if (s.startsWith('PIS')) return 'PIS — Programa de Integração Social (federal).';
  if (s.startsWith('IPI')) return 'IPI — Imposto sobre Produtos Industrializados (federal).';
  if (s.startsWith('IRPJ')) return 'IRPJ — Imposto de Renda da Pessoa Jurídica (federal).';
  if (s.startsWith('CSLL') || s.startsWith('CSOC'))
    return 'CSLL — Contribuição Social sobre o Lucro Líquido (federal).';
  if (s.startsWith('INSS')) return 'INSS — contribuição previdenciária (federal).';
  if (s.startsWith('CIDE'))
    return 'CIDE — Contribuição de Intervenção no Domínio Econômico (federal).';

  // Municipal
  if (s.startsWith('ISS')) return 'ISS — Imposto Sobre Serviços de qualquer natureza (municipal).';

  // Retenções na fonte
  if (s.startsWith('IRRF') || s === 'IRF') return 'IRRF — Imposto de Renda Retido na Fonte.';
  if (s === 'CRF' || s === 'CSRF' || s === 'COSIRF') {
    return 'CSRF — Contribuições Sociais Retidas na Fonte (PIS + COFINS + CSLL).';
  }

  // Simples Nacional
  if (s.startsWith('SIMPLES')) {
    return 'Simples Nacional — DAS, o imposto unificado recolhido pelos optantes do Simples.';
  }

  // Reforma tributária
  if (s.startsWith('IBS'))
    return 'IBS — Imposto sobre Bens e Serviços (reforma tributária; substitui ICMS e ISS).';
  if (s.startsWith('CBS'))
    return 'CBS — Contribuição sobre Bens e Serviços (reforma tributária; substitui PIS e COFINS).';

  // Outros conhecidos
  if (s.startsWith('PROTEGE')) {
    return 'PROTEGE — contribuição a fundo estadual (Goiás), vinculada a benefícios de ICMS.';
  }

  return 'Sigla de imposto/tributo destacado no documento fiscal.';
}
